<template>
  <div class="row my-3">
    <div class="form-check col-lg-3">
      <input id="showMun" type="checkbox" v-model="showOnlineClients" class="fs-1 me-2"
        @change="handleShowOnlineChange" />
      <label for="showMun">Show Online</label>
    </div>
    <div class="form-check col-lg-3">
      <input id="showbrgy" type="checkbox" v-model="showOfflineClients" class="fs-1 me-2"
        @change="handleShowOfflineClientsChange" />
      <label for="showbrgy">Show Offline</label>
    </div>
    <div class="form-check col-lg-3">
      <input id="showsitio" type="checkbox" v-model="showInactive" class="fs-1 me-2"
        @change="handleShowInactiveChange" />
      <label for="showsitio">Show Inactive</label>
    </div>
    <div class="col-lg-3">
      <form @submit.prevent="handleSearch">
        <div class="input-group">
          <input type="text" @focus="showResults = true" @blur="hideResults" v-model="keyword" required
            placeholder="Enter search keyword" class="form-control" />
          <button class="btn btn-secondary btn-sm" type="submit">
            <i class="bi bi-search"></i>
          </button>
        </div>
      </form>
      <div v-if="showResults && searchResults.length > 0"
        class="position-absolute w-25 mt-2 bg-white border rounded shadow-lg" style="z-index: 999999999999999" :class="{
          'w-25': windowWidth.value >= 992 /* w-25 for large screens (>= 992px) */,
          'w-100': windowWidth.value < 992 /* w-100 for small screens (< 992px) */,
        }">
        <ul class="list-unstyled m-0">
          <li v-for="(item, index) in searchResults" :key="index" class="dropdown-item py-2 px-3">
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div ref="mapDiv" style="width: 100%; height: 80vh" />
  <FullscreenModal :show="showClientInfoModal" @close="toggleClientInfoModal">
    <ClientInfo ref="clientInfoRef" @edit-client="handleEditClient" />
  </FullscreenModal>

  <FullscreenModal2 :show="showEditClientModal" @close="toggleEditClientModal">
    <EditClientInfo @cancel="toggleClientInfoModal" @update-success="handleUpdateSuccess" ref="editClientRef" />
  </FullscreenModal2>

  <FullscreenModal :show="showSearchClientModal" @close="toggleSearchClientModal">
    <SearchClient ref="searchClientRef" @search-complete="handleSearchComplete" @view-profile="handleViewProfile" @locate-client="handleLocateClient" />
  </FullscreenModal>
</template>

<script setup>
/* eslint-disable no-undef */

import { ref, onMounted, onUnmounted, watchEffect, nextTick } from "vue";
import areaService from "@/services/areaService";

import loader from "@/utils/googlemaps-config";
import Formatters from "@/utils/formatters";
import FullscreenModal from "../modals/FullscreenModal.vue";
import ClientInfo from "../infos/ClientInfo.vue";
import EditClientInfo from "../infos/EditClientInfo.vue";
import FullscreenModal2 from "../modals/FullscreenModal2.vue";
import SearchClient from "../inputs/SearchClient.vue";
function debounce(func, delay) {
  let timer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}
const searchClientRef = ref(null);
const clientInfoRef = ref(null);
const showClientInfoModal = ref(false);
const toggleClientInfoModal = () => {
  showClientInfoModal.value = !showClientInfoModal.value;
}

const showEditClientModal = ref(false);
const editClientRef = ref(null);
const toggleEditClientModal = () => {
  showEditClientModal.value = !showEditClientModal.value;
}
const handleSearchComplete =(searchkey)=>{
  keyword.value = searchkey;
  saveUserSession();
}
const handleUpdateSuccess = (client) => {
  toggleEditClientModal();
  clientInfoRef.value.getClientInfo(client.syspk_client);
}
const handleViewProfile = (client) => {
  toggleSearchClientModal();
  toggleClientInfoModal();
  clientInfoRef.value.getClientInfo(client.syspk_client);
}
const handleEditClient = (client) => {
  toggleEditClientModal();
  nextTick(() => {
    editClientRef.value.setClient(client);
  });
}

const showSearchClientModal = ref(false);
const toggleSearchClientModal = () => {
  showSearchClientModal.value = !showSearchClientModal.value;
}

const handleLocateClient = (client) => {
  // Set center to client coordinates
  toggleSearchClientModal();
  map.value.setCenter({
    lat: client.lat_client,
    lng: client.lng_client
  });

  // Set zoom to maximum (typically 21 is max for Google Maps)
  map.value.setZoom(21);

  // Alternative: Use fitBounds for better context
  // map.value.setZoom(map.value.getMaxZoomLevel());
}

const windowWidth = ref(window.innerWidth);
const mapDiv = ref(null);
const currentId = ref(0);
const currentCoordinates = ref(null);
const polygonType = ref("mun");
const showOfflineClients = ref(false);
const showInactive = ref(false);
const showHH = ref(false);
const showOnlineClients = ref(false);
const keyword = ref("");
const map = ref(null);
const modalAction = ref("summary");
const polygonsArray = [];
const labelsArray = [];
const modalTitle = ref("Polygon Information");
const showResults = ref(false);
const showModal = ref(false);
const markersMap = new Map();
const searchResults = ref([]);
let clickListener = null;

watchEffect(() => {
  const handleResize = () => {
    windowWidth.value = window.innerWidth;
  };
  window.addEventListener("resize", handleResize);
  return () => {
    window.removeEventListener("resize", handleResize);
  };
});

const toggleModal = () => {
  if (showModal.value === true) {
    currentId.value = 0;
    currentCoordinates.value = null;
  }
  showModal.value = !showModal.value;
};

const saveUserSession = () => {
  const pref = {
    showOnlineClients: showOnlineClients.value,
    keyword: keyword.value,
    showOfflineClients: showOfflineClients.value,
    showHH: showHH.value,
    showInactive: showInactive.value,
  };
  localStorage.setItem("heatmap-pref", JSON.stringify(pref));
};

const handleSearch = async () => {
  //spinnerService.show();
  saveUserSession();
  searchClientRef.value.initiateSearch(keyword.value);
  toggleSearchClientModal();
};

const getMunicipalVoterSummary = async (id, title) => {
  polygonType.value = "mun";
  modalAction.value = "summary";
  currentId.value = id;
  modalTitle.value = title;
  toggleModal();
};

const getBrgyVoterSummary = (id, title) => {
  polygonType.value = "brgy";
  modalAction.value = "summary";
  currentId.value = id;
  modalTitle.value = title;
  toggleModal();
};

const getSitioVoterSummary = (id, title) => {
  polygonType.value = "sitio";
  modalAction.value = "summary";
  currentId.value = id;
  modalTitle.value = title;
  toggleModal();
};



const handleShowOfflineClientsChange = async () => {
  saveUserSession();
  if (!map.value)
    return;
  clearMarkers();
  fetchMarkersFromDb(map.value.getBounds());
};

const handleShowInactiveChange = async () => {
  saveUserSession();
  clearMarkers();
  fetchMarkersFromDb(map.value.getBounds());
};



const handleShowOnlineChange = async () => {
  saveUserSession();
  if (!map.value)
    return;
  clearMarkers();
  fetchMarkersFromDb(map.value.getBounds());
};

const fetchMarkersFromDb = async (bounds) => {
  if (map.value && map.value.zoom > 8) {
    const b = JSON.parse(JSON.stringify(bounds));
    const markersInBound = await areaService.fetchMarkersFromDatabase(b);
    if (markersInBound === null || markersInBound.length === 0) return;
    markersInBound.forEach((markerData) => {
      addMarkerIfNotExists(
        markerData.lat_client,
        markerData.lng_client,
        `${markerData.fullname_client}`,
        markerData.syspk_client,
        markerData.isonline_client,
        markerData.isactive_client,
        markerData.balance_client,
        markerData.username_client,
        markerData.timeAgo
      );
    });
  }
};

const clearMarkers = () => {
  markersMap.forEach(function (marker) {
    marker.setMap(null);
  });
  markersMap.clear();
};



const addMarkerIfNotExists = (lat, lng, title, id, isonline_client, isactive_client, balance_client, username_client, timeAgo) => {
  const key = lat + "" + lng;
  if (!markersMap.has(key)) {
    if (showOnlineClients.value === false && isonline_client === 1) {

      return;
    }
    if (!showOfflineClients.value && isonline_client === 0) {
      return;
    }

    if (!showInactive.value && isactive_client === 0) {
      return;
    }

    let markerColor = isonline_client === 1 ? "green" : "red";

    if (isactive_client === 0 && isonline_client === 0) {
      markerColor = "yellow";
    }
    var marker = new google.maps.Marker({
      position: { lat: lat, lng: lng },
      map: map.value,
      title: title,
      customProperties: { id: id },
      icon: {
        url: `https://maps.google.com/mapfiles/ms/icons/${markerColor}-dot.png`,
        scaledSize: new google.maps.Size(32, 32)
      },
    });



    var infowindow = new google.maps.InfoWindow({
      maxWidth: 350,
      pixelOffset: new google.maps.Size(0, -30)
    });

    marker.addListener("click", async () => {
      // Format balance with currency symbol and proper decimal places
      const formattedBalance = Formatters.formatCurrency(balance_client || 0);
      // Get initials for avatar
      const initials = title
        .split(' ')
        .map(name => name[0])
        .join('')
        .toUpperCase()
        .substring(0, 2);

      // Determine balance status color
      const balanceStatus = isactive_client === 1 && isonline_client === 1 ? 'high' : isactive_client === 0 ? 'medium' : 'low';
      const balanceColor = balanceStatus === 'high' ? '#4CAF50' : balanceStatus === 'medium' ? '#FF9800' : '#F44336';

      const content = `
    <div style="
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
      padding: 0;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 4px 20px rgba(0,0,0,0.15);
      background: white;
    ">
      <!-- Header with gradient background -->
      <div style="
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        padding: 20px;
        color: white;
        display: flex;
        align-items: center;
        gap: 15px;
      ">
        <!-- Avatar with initials -->
        <div style="
          width: 60px;
          height: 60px;
          background: rgba(255,255,255,0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: 600;
          border: 3px solid white;
          box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        ">
          ${initials}
        </div>
        
        <!-- Title and username -->
        <div style="flex: 1;">
          <h3 style="
            margin: 0 0 5px 0;
            font-size: 20px;
            font-weight: 600;
            line-height: 1.2;
          ">${title}</h3>
          <div style="
            display: flex;
            align-items: center;
            gap: 5px;
            font-size: 14px;
            opacity: 0.9;
          ">
            <span style="font-size: 16px;">👤</span>
            <span>@${username_client || 'username'}</span>
          </div>
        </div>
      </div>

      <!-- Content body -->
      <div style="padding: 20px;">
        <!-- Full name with icon -->
        <div style="
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 15px;
          padding-bottom: 15px;
          border-bottom: 1px solid #eef2f6;
        ">
          <div style="
            width: 40px;
            height: 40px;
            background: #f0f4f8;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
          ">📋</div>
          <div>
            <div style="
              font-size: 12px;
              color: #666;
              margin-bottom: 2px;
            ">FULL NAME</div>
            <div style="
              font-size: 16px;
              font-weight: 600;
              color: #333;
            ">${title || 'N/A'}</div>
          </div>
        </div>

        <!-- Balance card -->
        <div style="
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          border-radius: 16px;
          padding: 15px;
          margin-bottom: 15px;
          border-left: 4px solid ${balanceColor};
        ">
          <div style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 5px;
          ">
            <span style="
              font-size: 14px;
              color: #666;
              display: flex;
              align-items: center;
              gap: 5px;
            ">
              <span>💰</span> Current Balance
            </span>
            <span style="
              font-size: 12px;
              padding: 4px 8px;
              background: ${balanceColor}20;
              color: ${balanceColor};
              border-radius: 20px;
              font-weight: 500;
            ">
              ${balanceStatus === 'high' ? 'Active' : balanceStatus === 'medium' ? 'Deactivated' : 'Offline'}
            </span>
          </div>
          <div style="
            font-size: 32px;
            font-weight: 700;
            color: ${balanceColor};
            line-height: 1.2;
          ">${formattedBalance}</div>
        </div>

        <!-- Quick actions -->
        <div style="
          display: grid;
          gap: 10px;
          margin-top: 15px;
        ">
          <button onclick="viewClientDetails('${id}')" style="
            background: #667eea;
            color: white;
            border: none;
            padding: 12px;
            border-radius: 12px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            transition: transform 0.2s, box-shadow 0.2s;
            box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
          "
          onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(102, 126, 234, 0.4)';"
          onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 8px rgba(102, 126, 234, 0.3)';">
            <span>👤</span> Profile
          </button>
         
        </div>

        <!-- Timestamp -->
        <div style="
          margin-top: 15px;
          text-align: center;
          font-size: 11px;
          color: #999;
          border-top: 1px solid #eef2f6;
          padding-top: 10px;
        ">
          ⏱️ Duration: ${timeAgo}
        </div>
      </div>
    </div>
  `;

      infowindow.setContent(content);
      infowindow.open(map.value, marker);

      // Optional: Call your existing function
      // getHouseholdContent(id, title, marker.position);
    });

    // Add these helper functions to handle button clicks
    window.viewClientDetails = (id) => {
      //console.log('Viewing profile for:', username);
      toggleClientInfoModal();
      clientInfoRef.value.getClientInfo(id);
      // Add your navigation logic here
      // window.location.href = `/client/${username}`;
    };

    window.viewTransactions = (username) => {
      console.log('Viewing transactions for:', username);
      // Add your navigation logic here
      // window.location.href = `/transactions/${username}`;
    };

    markersMap.set(key, marker);
  }
};


// eslint-disable-next-line
const clearPolygons = (type) => {
  polygonsArray.forEach(function (polygon) {
    if (polygon.type == type) polygon.setMap(null);
  });
  labelsArray.forEach(function (label) {
    if (label.customProperties && label.customProperties.type == type) label.setMap(null);
  });
};
// eslint-disable-next-line
const redrawEditablePolygon = (
  map,
  id,
  cityid,
  type,
  name,
  note,
  isLeading,
  coordinates
) => {
  if (!map || !coordinates) return;

  let fillColor = isLeading ? "#FF0000" : "#0000FF";
  if (isLeading && cityid === 3) {
    fillColor = "#006400";
  }
  const strokeColor = "#000000";

  const polygon = new google.maps.Polygon({
    paths: coordinates,
    map: map,
    fillColor: fillColor,
    strokeColor: strokeColor,
    editable: false,
  });

  if (type === "brgy") {
    polygon.setOptions({ zIndex: 100 });
  } else if (type === "sitio") {
    polygon.setOptions({ zIndex: 200 });
  }

  polygon.id = id;
  polygon.name = name;
  polygon.isLeading = isLeading;
  polygon.type = type;
  polygon.cityid = cityid;
  polygon.note = note;

  const bounds = new google.maps.LatLngBounds();
  coordinates.forEach((point) => {
    bounds.extend(new google.maps.LatLng(point.lat, point.lng));
  });
  map.fitBounds(bounds);

  const label = new google.maps.Marker({
    position: bounds.getCenter(),
    map: map,
    label: {
      text: name,
      fontSize: type === "mun" ? "18px" : "10px",
      fontWeight: "bold",
      color: isLeading ? "#000000" : "#800080",
    },
    icon: {
      url: "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=",
      size: new google.maps.Size(1, 1),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(0, 0),
    },
    optimized: false,
    customProperties: { id, name, type, cityid, note },
  });

  google.maps.event.addListener(polygon, "click", () => {
    if (polygon.type === "mun") {
      getMunicipalVoterSummary(polygon.id, polygon.name);
    } else if (polygon.type === "brgy") {
      getBrgyVoterSummary(polygon.id, `${polygon.note} - ${polygon.name}`);
    } else {
      getSitioVoterSummary(polygon.id, `${polygon.note} - ${polygon.name}`);
    }
  });

  polygonsArray.push(polygon);
  labelsArray.push(label);
  return polygon;
};



onMounted(async () => {
  try {
    // Load preferences first
    const prevSession = JSON.parse(localStorage.getItem("heatmap-pref"));
    if (prevSession && prevSession !== null) {
      showOnlineClients.value = prevSession.showOnlineClients;
      showOfflineClients.value = prevSession.showOfflineClients;
      showHH.value = prevSession.showHH;
      showInactive.value = prevSession.showInactive;
      keyword.value = prevSession.keyword;
    }

    // Load Google Maps
    await loader.load();

    // Use a small delay to ensure DOM is ready
    setTimeout(() => {
      try {
        // Check if mapDiv exists
        if (!mapDiv.value) {
          console.error("Map container element not found!");
          return;
        }

        // Initialize map
        if (process.env.VUE_APP_DISTRICT === 5) {
          map.value = new google.maps.Map(mapDiv.value, {
            center: { lat: 14.295265, lng: 121.068277 },
            zoom: 11,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: true,
            streetViewControl: true,
            fullscreenControl: true
          });
        } else {
          map.value = new google.maps.Map(mapDiv.value, {
            center: { lat: 11.074797, lng: 124.58852 },
            zoom: 11,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: true,
            streetViewControl: true,
            fullscreenControl: true
          });
        }


        // Load initial data
        Promise.all([
          // handleShowOnlineChange(),
          //  handleShowOfflineClientsChange(),
          //handleShowBrgyChange(),
          //  handleShowSitioChange()
        ]).then(() => {
          console.log("Initial data loaded successfully");
        });

        // Add bounds changed listener
        const debouncedFetchMarkers = debounce(fetchMarkersFromDb, 500);

        map.value.addListener("bounds_changed", async () => {
          const newBounds = map.value.getBounds();
          debouncedFetchMarkers(newBounds);
        });

      } catch (mapError) {
        console.error("Error creating map:", mapError);
      }
    }, 100); // Small delay to ensure DOM is ready

  } catch (error) {
    console.error("Error loading Google Maps API or fetching data:", error);
  }
});
function hideResults() {
  setTimeout(() => {
    showResults.value = false;
  }, 200);
}

onUnmounted(() => {
  if (clickListener) {
    clickListener.remove();
  }
  polygonsArray.forEach((polygon) => polygon.setMap(null));
  labelsArray.forEach((label) => label.setMap(null));
  map.value = null;
});
</script>
<style>
#map {
  height: 400px;
  width: 100%;
}
</style>
